import { TabNavigation, Bleed } from '@cellula/react';
import { withTranslation } from '@application/i18n/with_translation';
import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { AnalyticCategories } from '@application/analytic/analytic.service';
import { Title } from '@component/title.component';

export function Heading(props: { bleed?: boolean }) {
	const analyticCtx = useAnalyticContext();

	function analyticQuirk_handleTabClick(value: string): void {
		analyticCtx.trackEvent(
			AnalyticCategories.Visits,
			value === 'tab1' ? 'Clicked: Ongoing cases-tab' : 'Clicked: Completed cases-tab',
		);
	}

	return (
		<>
			<Title title={withTranslation('PW.Component.Visits.Title')} />

			<Bleed bleedAmount={props.bleed === false ? '0px' : '8px'}>
				<TabNavigation.Bar label={withTranslation('PW.Component.Visits.TabBar.Label')} onClick={analyticQuirk_handleTabClick} />
			</Bleed>
		</>
	);
}
